import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Typography,
  Box,
  useTheme,
  Theme
} from '@mui/material'
import { Download as DownloadIcon } from '@mui/icons-material'
import Storage from '../../../lib/Storage'
import { Product } from '../hooks/useDigitalOrders'
import { handleCsvDownload } from '@/utils/handleCsvDownloads'

const styles = {
  tableCell: {
    '&.MuiTableCell-head': {
      backgroundColor: '#4b65d5',
      color: 'common.white'
    }
  },
  downloadButton: {
    backgroundColor: '#4b65d5',
    color: 'white',
    '&:hover': {
      backgroundColor: '#3a4fb3'
    }
  },
  container: {
    width: '100%',
    mb: 1,
    padding: 1
  },
  header: {
    mb: 3,
    display: 'flex',
    alignItems: 'center'
  },
  title: {
    color: '#333'
  },
  titleSpanAndSeparator: (theme: Theme) => ({
    color:
      theme.palette.mode === 'dark'
        ? theme.palette.text.secondary
        : theme.palette.text.primary
  }),
  titleSpan2: {
    color: '#4b65d5'
  },
  table: {
    minWidth: 650
  },
  tableRow: {
    '&:last-child td, &:last-child th': { border: 0 }
  }
}

export type DigitalOrdersListProps = {
  products: Product[]
}

export const DigitalOrdersList = ({ products }: DigitalOrdersListProps) => {
  const theme = useTheme()

  const { subname } = Storage().getActiveRole()

  return (
    <Box sx={styles.container}>
      <Box sx={styles.header}>
        <Typography variant="h5" component="h1" sx={styles.title}>
          <span style={styles.titleSpanAndSeparator(theme)}>{subname}</span>
          <span style={styles.titleSpanAndSeparator(theme)}>{' / '}</span>
          <span style={styles.titleSpan2}>Digital Orders</span>
        </Typography>
      </Box>

      <TableContainer component={Paper}>
        <Table sx={styles.table}>
          <TableHead>
            <TableRow>
              <TableCell sx={styles.tableCell}>Product Name</TableCell>
              <TableCell sx={styles.tableCell} align="center">
                Order Count
              </TableCell>
              <TableCell sx={styles.tableCell} align="center">
                Order CSV
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {products.map((product) => (
              <TableRow key={product.id} sx={styles.tableRow}>
                <TableCell component="th" scope="product">
                  {product.name}
                </TableCell>
                <TableCell align="center">
                  {product.total_items_count}
                </TableCell>
                <TableCell align="center">
                  <Button
                    variant="contained"
                    startIcon={<DownloadIcon />}
                    onClick={() => handleCsvDownload(product.id, product.name)}
                    size="small"
                    sx={styles.downloadButton}
                  >
                    Download
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  )
}
